/* Customily form parity: required-field guard + CustomAll selected swatches. */
(function () {
  'use strict';

  if (document.documentElement.hasAttribute('data-sc-customily-form-parity-installed')) return;
  /* No-op on PZ in-house PDPs (the theme block only loads this file for Customily; defense in depth). */
  if (document.querySelector('[data-pz-provider]')) return;
  document.documentElement.setAttribute('data-sc-customily-form-parity-installed', 'true');

  var ROOT_SELECTOR = '#cl_optionsapp';
  var INVALID_CLASS = 'sc-customily-option-invalid';
  var SELECTED_MARKER = 'data-sc-customall-selected';
  var rootObserver = null;
  var observedRoot = null;
  var rootParentObserver = null;
  var syncTimer = null;
  var requiredId = 0;
  var NOTICE_ID = 'sc-customily-required-notice';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Only options the shopper can see are required. Customily keeps hidden options in the DOM
   * (visually-hidden="true", or display:none on the row/an ancestor when conditions hide it);
   * validating those blocked Add to cart with no visible message (hotfix 30/09, sc1512428). */
  function isRowShown(row) {
    if (row.getAttribute('visually-hidden') === 'true' || row.hidden) return false;
    return row.getClientRects().length > 0;
  }

  function requiredRows() {
    var rows = [];
    var labels = document.querySelectorAll('.customily-required-label');
    for (var i = 0; i < labels.length; i++) {
      var row = labels[i].closest('.customily_option');
      if (!row || row.classList.contains('cl-has-checkbox') || !isRowShown(row)) continue;
      if (rows.indexOf(row) === -1) rows.push(row);
    }
    return rows;
  }

  function isPlaceholder(value) {
    var trimmed = (value || '').trim();
    return !trimmed || /^(select\b|choose\b|please select\b|\s*\.\.\.\s*$)/i.test(trimmed);
  }

  function isOptionFilled(row) {
    var textFields = row.querySelectorAll(
      'input[type="text"]:not(.csh-dropdown-filter), input[type="email"], input[type="number"], ' +
      'input[type="tel"], input[type="url"], textarea'
    );
    if (textFields.length) {
      for (var i = 0; i < textFields.length; i++) {
        /* A single space is an intentional Customily value meaning no text. */
        if (textFields[i].value.length === 0) return false;
      }
      return true;
    }

    var choices = row.querySelectorAll('input[type="radio"], input[type="checkbox"]');
    if (choices.length) return !!row.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');

    var files = row.querySelectorAll('input[type="file"]');
    if (files.length) {
      for (var j = 0; j < files.length; j++) {
        if (files[j].files && files[j].files.length) return true;
      }
    }

    var selects = row.querySelectorAll('select');
    if (selects.length) {
      for (var k = 0; k < selects.length; k++) {
        if (isPlaceholder(selects[k].value)) return false;
      }
      return true;
    }

    var hidden = row.querySelectorAll('input[type="hidden"][name^="properties"]');
    for (var h = 0; h < hidden.length; h++) {
      if (hidden[h].value.length > 0) return true;
    }

    /* Customily may clear the native file input after uploading while keeping
     * the processed asset URL/id in a hidden product property. Only fail a
     * file row after that persisted-value fallback has been checked. */
    if (files.length) return false;

    var dropdown = row.querySelector('.csh-dropdown-input-container');
    return dropdown ? !isPlaceholder((dropdown.textContent || '').replace(/\s+/g, ' ')) : false;
  }

  function setRowInvalid(row, invalid) {
    row.classList.toggle(INVALID_CLASS, invalid);
    var label = row.querySelector('.customily-required-label');
    var message = label && label.querySelector('span');
    var control = row.querySelector(
      'input:not([type="hidden"]):not([tabindex="-1"]), textarea, select'
    ) || row.querySelector('[role="button"], .csh-dropdown-input-container, label[for]');

    if (!message) return;

    if (!message.id) message.id = 'sc-customily-required-' + (++requiredId);
    message.setAttribute('role', 'alert');
    message.setAttribute('aria-live', 'polite');

    if (control) {
      if (invalid) {
        if (!control.hasAttribute('data-sc-required-aria-invalid-previous')) {
          var previousInvalid = control.getAttribute('aria-invalid');
          control.setAttribute(
            'data-sc-required-aria-invalid-previous',
            previousInvalid === null ? '__missing__' : previousInvalid
          );
        }
        control.setAttribute('aria-invalid', 'true');
        var describedBy = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (describedBy.indexOf(message.id) === -1) describedBy.push(message.id);
        control.setAttribute('aria-describedby', describedBy.join(' '));
      } else {
        var previous = control.getAttribute('data-sc-required-aria-invalid-previous');
        if (previous !== null) {
          if (previous === '__missing__') control.removeAttribute('aria-invalid');
          else control.setAttribute('aria-invalid', previous);
          control.removeAttribute('data-sc-required-aria-invalid-previous');
        }
        var remaining = (control.getAttribute('aria-describedby') || '').split(/\s+/).filter(function (id) {
          return id && id !== message.id;
        });
        if (remaining.length) control.setAttribute('aria-describedby', remaining.join(' '));
        else control.removeAttribute('aria-describedby');
      }
    }

    if (invalid) {
      message.setAttribute('data-sc-required-shown', 'true');
      message.style.display = 'inline';
      if (!prefersReducedMotion()) {
        message.classList.remove('customily-text-bounce-enter', 'customily-text-bounce-enter-active');
        void message.offsetWidth;
        message.classList.add('customily-text-bounce-enter', 'customily-text-bounce-enter-active');
      }
    } else if (message.getAttribute('data-sc-required-shown') === 'true') {
      message.style.display = 'none';
      message.removeAttribute('data-sc-required-shown');
      message.classList.remove('customily-text-bounce-enter', 'customily-text-bounce-enter-active');
    }
  }

  function focusInvalidRow(row) {
    row.scrollIntoView({ behavior: prefersReducedMotion() ? 'auto' : 'smooth', block: 'center' });
    requestAnimationFrame(function () {
      var control = row.querySelector(
        'input:not([type="hidden"]):not([tabindex="-1"]), textarea, select'
      ) || row.querySelector('[role="button"], .csh-dropdown-input-container, label[for]') || row;
      if (!control.hasAttribute('tabindex') && !/^(INPUT|TEXTAREA|SELECT)$/.test(control.tagName)) {
        control.setAttribute('tabindex', '-1');
      }
      if (control.focus) control.focus({ preventScroll: true });
    });
  }

  /* Blocking Add to cart must never be silent: if the invalid row has no visible required
   * message, show a notice above the button. */
  function setNotice(show) {
    var notice = document.getElementById(NOTICE_ID);
    if (!show) {
      if (notice) notice.parentNode.removeChild(notice);
      return;
    }
    var btn = document.getElementById('customily-cart-btn');
    if (notice || !btn || !btn.parentNode) return;
    notice = document.createElement('div');
    notice.id = NOTICE_ID;
    notice.setAttribute('role', 'alert');
    notice.setAttribute('aria-live', 'assertive');
    notice.style.cssText = 'color:#d82c0d;font-size:14px;margin:0 0 8px;';
    notice.textContent = 'Please complete all required options above.';
    btn.parentNode.insertBefore(notice, btn);
  }

  function hasVisibleMessage(row) {
    var label = row.querySelector('.customily-required-label');
    var message = label && label.querySelector('span');
    return !!(message && message.getClientRects().length);
  }

  function validateRequired(options) {
    var rows = requiredRows();
    var firstInvalid = null;
    for (var i = 0; i < rows.length; i++) {
      var invalid = !isOptionFilled(rows[i]);
      setRowInvalid(rows[i], invalid);
      if (invalid && !firstInvalid) firstInvalid = rows[i];
    }
    if (firstInvalid && (!options || options.reveal !== false)) {
      focusInvalidRow(firstInvalid);
      setNotice(!hasVisibleMessage(firstInvalid));
    }
    if (!firstInvalid) setNotice(false);
    return !firstInvalid;
  }

  function clearFilledInvalidRows() {
    var rows = document.querySelectorAll('.' + INVALID_CLASS);
    for (var i = 0; i < rows.length; i++) {
      if (isOptionFilled(rows[i]) || !isRowShown(rows[i])) setRowInvalid(rows[i], false);
    }
    if (!document.querySelector('.' + INVALID_CLASS)) setNotice(false);
  }

  function resetSelectedLabel(label) {
    if (!label || !label.hasAttribute(SELECTED_MARKER)) return;
    label.removeAttribute(SELECTED_MARKER);
    label.style.removeProperty('border');
    label.style.removeProperty('border-radius');
    label.style.removeProperty('box-shadow');
    label.style.removeProperty('outline');
    label.style.removeProperty('outline-offset');
  }

  function applySelectedLabel(label) {
    if (!label) return;
    label.setAttribute(SELECTED_MARKER, 'true');
    label.style.setProperty('border', '2px solid #6168ff', 'important');
    label.style.setProperty('border-radius', '4px', 'important');
    label.style.setProperty('box-shadow', 'none', 'important');
  }

  function syncSelectedSwatches() {
    var styled = document.querySelectorAll('label[' + SELECTED_MARKER + ']');
    for (var i = 0; i < styled.length; i++) {
      var input = styled[i].previousElementSibling;
      if (!input || !input.checked) resetSelectedLabel(styled[i]);
    }
    var checked = document.querySelectorAll('.customily-swatch input[type="radio"]:checked');
    for (var j = 0; j < checked.length; j++) {
      var label = checked[j].nextElementSibling;
      if (!label || label.tagName !== 'LABEL') {
        label = document.querySelector('label[for="' + CSS.escape(checked[j].id) + '"]');
      }
      applySelectedLabel(label);
    }
  }

  function scheduleSync() {
    clearTimeout(syncTimer);
    requestAnimationFrame(syncSelectedSwatches);
    syncTimer = setTimeout(syncSelectedSwatches, 80);
  }

  function attachRoot() {
    var root = document.querySelector(ROOT_SELECTOR);
    if (!root) return false;
    if (root === observedRoot) return true;
    if (rootObserver) rootObserver.disconnect();
    observedRoot = root;
    root.setAttribute('data-sc-form-parity', 'true');
    rootObserver = new MutationObserver(scheduleSync);
    rootObserver.observe(root, { childList: true, subtree: true });
    if (rootParentObserver) rootParentObserver.disconnect();
    if (root.parentNode) {
      rootParentObserver = new MutationObserver(function () {
        var currentRoot = document.querySelector(ROOT_SELECTOR);
        if (currentRoot && currentRoot !== observedRoot) attachRoot();
      });
      rootParentObserver.observe(root.parentNode, { childList: true });
    }
    scheduleSync();
    return true;
  }

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var atc = event.target.closest('#customily-cart-btn');
    if (!atc || validateRequired()) return;
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }, true);

  document.addEventListener('sc-customily-before-preview', function (event) {
    if (!validateRequired()) event.preventDefault();
  }, true);

  ['input', 'change', 'click'].forEach(function (eventName) {
    document.addEventListener(eventName, function (event) {
      if (!event.target || !event.target.closest || !event.target.closest('.customily_option')) return;
      setTimeout(clearFilledInvalidRows, 0);
      scheduleSync();
    }, true);
  });

  window.addEventListener('customily-options-changed', function () {
    setTimeout(clearFilledInvalidRows, 0);
    scheduleSync();
  });
  window.addEventListener('customily-canvas-rendered', scheduleSync);

  if (!attachRoot()) {
    var rootPoll = setInterval(function () {
      if (attachRoot()) clearInterval(rootPoll);
    }, 300);
    setTimeout(function () { clearInterval(rootPoll); }, 30000);
  }

})();
